export const LOAD_PRODUCTS = '[SHOP] LOAD_PRODUCTS'
export const LOAD_PRODUCT = '[SHOP] LOAD_PRODUCT'
export const LOAD_HAS_MORE = '[SHOP] LOAD_HAS_MORE'
export const LOAD_SHOPPING_CART = '[SHOP] LOAD_SHOPPING_CART'
export const ADD_TO_SHOPPING_CART = '[SHOP] ADD_TO_SHOPPING_CART'
